import * as Apollo from "@apollo/client";
import { useMemo } from "react";
import { useUser } from "@/auth/useUser";
import {
  MedspaServicesAndProductsQuery,
  useMedspaServicesAndProductsQuery,
} from "@/graphql/queries/settings/medspaServicesAndProducts.graphql.types";
import { MedspaServicesAndProductsQueryVariables } from "./../../graphql/queries/settings/medspaServicesAndProducts.graphql.types";

type ServicesAndProductsCustomOptionsProps = Apollo.QueryHookOptions<
  MedspaServicesAndProductsQuery,
  MedspaServicesAndProductsQueryVariables
>;

export default function useMedspaServicesAndProducts(
  customOptions = {} as ServicesAndProductsCustomOptionsProps
) {
  const { medspa } = useUser();

  const { data, refetch } = useMedspaServicesAndProductsQuery({
    variables: {
      id: medspa,
    },
    skip: !medspa,
    ...customOptions,
  });

  return useMemo(
    () => ({
      data,
      loading: !data,
      refetch,
    }),
    [data, refetch]
  );
}
